import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import RotatingProductCards from "../components/RotatingProductCards";
import products from "../data/products";
import "../styles/HandiCrafts.css";

// Self-contained page: owns its own filter state, doesn't lift state up.
export default function HandiCrafts() {
  const categories = useMemo(() => ["All", ...new Set(products.map((p) => p.category))], []);
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredProducts =
    activeCategory === "All" ? products : products.filter((p) => p.category === activeCategory);

  return (
    <div className="tp-handicrafts">
      <section className="tp-handicrafts-hero tp-floral-bg2">
        <div className="tp-container">
          <span className="tp-eyebrow">Handmade Eco-Friendly Kerala</span>
          <h1 className="tp-section-heading">Product Catalogue</h1>
          <p className="tp-section-sub">
            Every piece is hand-assembled from Kerala's natural waste — corn husk, paddy straw,
            pistachio shells, sola wood, areca leaf, and more. Browse the full Terra Bloom Studio
            collection below.
          </p>
        </div>
      </section>

      <section className="tp-section tp-handicrafts-catalogue">
        <div className="tp-container">
          <div className="tp-handicrafts-filters" role="tablist" aria-label="Filter by category">
            {categories.map((category) => (
              <button
                key={category}
                role="tab"
                aria-selected={activeCategory === category}
                className={`tp-handicrafts-filter ${
                  activeCategory === category ? "tp-handicrafts-filter--active" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          {/* <RotatingProductCards
            key={activeCategory}
            items={filteredProducts}
            title={`${activeCategory} (${filteredProducts.length})`}
          /> */}

          <div className="tp-handicrafts-grid">
            {filteredProducts.map((product) => (
              <article className="tp-handicrafts-card" key={product.id}>
                <div className="tp-handicrafts-card__photo-wrap">
                  <img src={product.image} alt={product.name} loading="lazy" />
                </div>
                <div className="tp-handicrafts-card__info">
                  <span className="tp-handicrafts-card__category">{product.category}</span>
                  <h4>{product.name}</h4>
                  <span className="tp-handicrafts-card__code">Code: {product.code}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tp-handicrafts-cta">
        <div className="tp-container tp-handicrafts-cta__inner">
          <div>
            <h2>Looking for bulk orders or custom designs?</h2>
            <p>We offer tailored colour schemes, arrangements, and bulk packaging for weddings, festivals, and corporate gifting.</p>
          </div>
          <Link to="/request-quote" className="tp-btn tp-btn--primary">
            Request a Quote
            <Icon name="arrow" size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
